import React, { /*useState,*/ useMemo } from 'react';
//import { connect } from 'react-redux';
import MUIDataTable from 'mui-datatables';
/*import {
  Modal,
  Button
} from '@material-ui/core';*/
//import { makeStyles } from '@material-ui/core/styles';

//import CustomToolbar from 'components/CustomToolbar/CustomToolbar';

//import { deleteExpense } from 'redux/actions';
//import { Employee_Salary, Employee_Expense } from 'variables/expenseTypes';
import { admin } from 'variables/userAccountTypes';

/*const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  },
}));*/

const ExpensesTable = (props) => {

  //const classes = useStyles();

  //const [rowsSelected, setRowsSelected] = useState([]);
  //const [openModal, setOpenModal] = useState(false);

  const filteredExpenses = useMemo(() => {
    //if the user is single or standard, only that user's Expenses will be shown,
    //else Expenses of all users will be shown.
    if(props.activeUserType === admin) return props.expenses.filter(expense => expense.userId === props.usersArray[props.userTabValue].id);
    else return props.expenses;

  }, [props.activeUserType, props.expenses, props.usersArray, props.userTabValue]);

  const tableData = useMemo(() => {
    const initialTableData = [];

    for ( let i = 0; i < filteredExpenses.length; i++ ) {
      const expense = filteredExpenses[i];
      initialTableData.push({
        id: expense.id,
        displayId: expense.displayId,
        type: expense.type,
        vatable: expense.totalVat ? "Yes" : "No",
        description: expense.description,
        total: expense.total
      });
    }
    
    return initialTableData;
    
  }, [filteredExpenses]);

  const columns = [
    { label: "ID", name: "displayId" },
    { label: "Expense Type", name: "type" },
    { label: "Vatable", name: "vatable" },
    { label: "Description", name: "description" },
    { label: "Expense Amount", name: "total" }
  ];

  /*const onRowSelectionChange = (curr, all, rowsSelected) => {
    setRowsSelected(rowsSelected);
  };

  const handleModalOpen = () => {
    setOpenModal(true);
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const deleteExpenses = () => {
    rowsSelected.forEach(index => {
      if( !(tableData[index].type === Employee_Expense || tableData[index].type === Employee_Salary) ) {
        props.deleteExpense({id: tableData[index].id, userId: props.activeUserId});
      }
    })
    handleModalClose();
    setRowsSelected([]);
  };

  const customToolbarSelect = () => {
    return(
      <CustomToolbar
        switchy={4}
        element="Expense"
        setDelete={handleModalOpen}
      />
    )
  };*/

  const options = {
    //onRowSelectionChange,
    //customToolbarSelect,
    //selectableRowsOnClick: true,
    selectableRows: 'none',
    //rowsSelected,
  };

  return (
    <React.Fragment>
    <MUIDataTable 
      title={"Expense List"}
      data={tableData}
      columns={columns}
      options={options}
    />
    {/*<Modal
      open={openModal}
      onClose={handleModalClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div style={{ top: "30%", left: "35%" }} className={classes.paper}>
        <h2 id="simple-modal-title">Delete Expense(s)?</h2>
        <p id="simple-modal-description">
          The Following Expense(s) will be Deleted...
          Employee Salary and Employee Expenses will not be Deleted.
          {}
        </p>
        <Button
          color="secondary"
          variant="contained"
          onClick={deleteExpenses}
        >
          Delete
        </Button>
        <Button sx={{ mx: 1 }} onClick={handleModalClose}>
          Cancel
        </Button>
      </div>
    </Modal>*/}
    </React.Fragment>
  )
};

//export default connect (null, {deleteExpense}) (ExpensesTable);
export default ExpensesTable;